import React from "react";
import "./Footer.css";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import payment from "../assets/images/payment.png";
import { Link } from "react-router-dom"; //Link
import Accordion from "react-bootstrap/Accordion"; //Accordion
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"; 
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FiYoutube } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";




export default function Footer() {
  return (
    <div className="footer_outer">
      <div className="footer_main">
        <div className="container-fluid">
          <div className="row footer_links_row">
            <div className="col-lg-8 col-md-8 col-sm-12 col-12">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                  <div className="footer_item">
                    <h5>About us</h5>
                    <ul>
                      <li>
                        <Link to="/products">The Founder</Link>
                      </li>
                      <li>
                        <Link to="/products">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/products">Legacy</Link>
                      </li>
                      <li>
                        <Link to="/products">Sustainability</Link>
                      </li>
                      <li>
                        <Link to="/products">Craftsmanship</Link>
                      </li>
                      <li>
                        <Link to="/products">Blog</Link>
                      </li>
                      <li>
                        <Link to="/products">Catalogues</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                  <div className="footer_item">
                    <h5>categories</h5>
                    <ul>
                       <li>
                        <Link to="/products">The Founder</Link>
                      </li>
                      <li>
                        <Link to="/products">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/products">Legacy</Link>
                      </li>
                      <li>
                        <Link to="/products">Sustainability</Link>
                      </li>
                      <li>
                        <Link to="/products">Craftsmanship</Link>
                      </li>
                      <li>
                        <Link to="/products">Blog</Link>
                      </li>
                      <li>
                        <Link to="/products">Catalogues</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                  <div className="footer_item">
                    <h5>Service</h5>
                    <ul>
                      <li>
                        <Link to="/products">The Founder</Link>
                      </li>
                      <li>
                        <Link to="/products">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/products">Legacy</Link>
                      </li>
                      <li>
                        <Link to="/products">Sustainability</Link>
                      </li>
                      <li>
                        <Link to="/products">Craftsmanship</Link>
                      </li>
                      <li>
                        <Link to="/products">Blog</Link>
                      </li>
                      <li>
                        <Link to="/products">Catalogues</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                  <div className="footer_item">
                    <h5>Policies</h5>
                    <ul>
                      <li>
                        <Link to="/terms">Terms & Conditions</Link>
                      </li>
                      <li>
                        <Link to="/privacy">Privacy Policy</Link>
                      </li>
                       <li>
                        <Link to="/products">The Founder</Link>
                      </li>
                      <li>
                        <Link to="/products">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/products">Legacy</Link>
                      </li>
                      <li>
                        <Link to="/products">Sustainability</Link>
                      </li>
                      <li>
                        <Link to="/products">Craftsmanship</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
              <div className="footer_item">
                <h5>Subscribe To Newsletter</h5>
                <form className="d-flex" role="search">
                  <input
                    className="form-control"
                    type="search"
                    aria-label="Search"
                    placeholder="Email"
                  />
                  <button className="" type="submit">
                    Subcribe
                  </button>
                </form>
              </div>

              <div className="footer_item footer_item_contact">
                <h5>Contact Us</h5>
                <ul>
                  <li>
                    <a href="tel:+918739990555">+91 87399 90555</a>
                  </li>
                  <li>
                    <a href="mailto:textile@gmail.com">textile@gmail.com</a>
                  </li>
                </ul>

                <div className="social_icons">
                  <ul>
                    <li>
                      <a href="#">
                        <FaFacebookF />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                       <FaInstagram />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <FaLinkedinIn />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                       <FaXTwitter />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                       <FiYoutube />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                       <FaWhatsapp />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="mobile_footer_accord ">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header>About us</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    <li>
                      <Link to="/products">The Founder</Link>
                    </li>
                    <li>
                      <Link to="/products">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/products">Legacy</Link>
                    </li>
                    <li>
                      <Link to="/products">Sustainability</Link>
                    </li>
                    <li>
                      <Link to="/products">Craftsmanship</Link>
                    </li>
                    <li>
                      <Link to="/products">Blog</Link>
                    </li>
                    <li>
                      <Link to="/products">Catalogues</Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Categories</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    <li>
                      <Link to="/products">The Founder</Link>
                    </li>
                    <li>
                      <Link to="/products">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/products">Legacy</Link>
                    </li>
                    <li>
                      <Link to="/products">Sustainability</Link>
                    </li>
                    <li>
                      <Link to="/products">Craftsmanship</Link>
                    </li>
                    <li>
                      <Link to="/products">Blog</Link>
                    </li>
                    <li>
                      <Link to="/products">Catalogues</Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Service</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    <li>
                      <Link to="/products">The Founder</Link>
                    </li>
                    <li>
                      <Link to="/products">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/products">Legacy</Link>
                    </li>
                    <li>
                      <Link to="/products">Sustainability</Link>
                    </li>
                    <li>
                      <Link to="/products">Craftsmanship</Link>
                    </li>
                    <li>
                      <Link to="/products">Blog</Link>
                    </li>
                    <li>
                      <Link to="/products">Catalogues</Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header>Policies</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    <li>
                      <Link to="/products">The Founder</Link>
                    </li>
                    <li>
                      <Link to="/products">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/products">Legacy</Link>
                    </li>
                    <li>
                      <Link to="/products">Sustainability</Link>
                    </li>
                    <li>
                      <Link to="/products">Craftsmanship</Link>
                    </li>
                    <li>
                      <Link to="/products">Blog</Link>
                    </li>
                    <li>
                      <Link to="/products">Catalogues</Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="subscribe_mobile_footer">
              <div className="footer_item">
                <h5>Subscribe To Newsletter</h5>
                <form className="d-flex" role="search">
                  <input
                    className="form-control"
                    type="search"
                    aria-label="Search"
                    placeholder="Email"
                  />
                  <button className="" type="submit">
                    Subcribe
                  </button>
                </form>
              </div>

              <div className="footer_item footer_item_contact">
                <h5>Contact Us</h5>
                <ul>
                  <li>
                    <a href="tel:+918739990555">+91 87399 90555</a>
                  </li>
                  <li>
                    <a href="mailto:textile@gmail.com">textile@gmail.com</a>
                  </li>
                </ul>

                <div className="social_icons">
                   <ul>
                    <li>
                      <a href="#">
                        <FaFacebookF />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                       <FaInstagram />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <FaLinkedinIn />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                       <FaXTwitter />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                       <FiYoutube />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                       <FaWhatsapp />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer_copyright">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6">
              <div className="copyright_text">
                <p>Copyright 2026 Textile. All right reserved.</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="copyright_text text-end">
                <a href="#">
                  {" "}
                  <img src={payment} alt="payment" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
